import { render, staticRenderFns } from "./vmRecordOrUpload.vue?vue&type=template&id=3d306443&"
import script from "./vmRecordOrUpload.vue?vue&type=script&lang=js&"
export * from "./vmRecordOrUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports